<div class="w-p-100 flex flex-row justify-between items-center">
  <div *ngIf="item && item.cells" class="grid-cell-ellipsis m-r-5"
       matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
    {{item.cells[fieldDefinition.key]?.displayText !== '' ? item.cells[fieldDefinition.key]?.displayText : 'N/A'}}
  </div>
  <ul class="grid-mini-button-container m-l-10">
    <li>
      <button
        *ngIf="item.cells[fieldDefinition.key]?.value?.blocks && item.cells[fieldDefinition.key]?.value?.blocks.length > 0"
        mat-button class="grid-mini-button"
        matTooltip="Click here to view progressive block" (click)="openProgressiveBlock()">
        P
      </button>
    </li>
    <li>
      <button *ngIf="item.cells[fieldDefinition.key]?.value?.footnote" mat-button class="grid-mini-button"
              matTooltip="Click here to view footnote" (click)="openFootnoteDialog()">
        F
      </button>
    </li>
  </ul>


</div>


